export default __webpack_public_path__ + "static/media/portfolio-icon.6c48163a.svg";